import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface CourseCurriculum {
  curriculumId: string;
  curriculumTitle: string;
}

export function useCourseCurriculum(courseId: string | undefined) {
  return useQuery({
    queryKey: ["course-curriculum", courseId],
    queryFn: async (): Promise<CourseCurriculum | null> => {
      if (!courseId) return null;

      const { data, error } = await supabase
        .from("curriculum_courses")
        .select(`
          curriculum_id,
          curricula (
            id,
            title
          )
        `)
        .eq("course_id", courseId)
        .limit(1)
        .maybeSingle();

      if (error || !data) return null;

      const curriculum = data.curricula as { id: string; title: string } | null;
      if (!curriculum) return null;

      return {
        curriculumId: curriculum.id,
        curriculumTitle: curriculum.title,
      };
    },
    enabled: !!courseId,
  });
}
